var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-app',[_c('Alert',{attrs:{"is-active":_vm.isAlertActive}}),_c('Confirm',{attrs:{"is-active":_vm.isConfirmActive}}),_c('router-view')],1)}
var staticRenderFns = []

export { render, staticRenderFns }